import React, { useState, useEffect, useCallback } from 'react';
import { Drawer, Button, TextField, Box, Typography } from '@mui/material';
import { getDefaultDateRange } from '../../../../../lib/utils';

const DashboardFilters = ({ open, onClose, onApply, dateFilters }) => {
  const { startDate: defaultStartDate, endDate: defaultEndDate } = dateFilters;

  const today = new Date().toISOString().split('T')[0];

  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);

  useEffect(() => {
    if (open) {
      setStartDate(defaultStartDate);
      setEndDate(defaultEndDate);
    }
  }, [open, defaultStartDate, defaultEndDate]);

  const validateDates = useCallback((newStartDate, newEndDate) => {
    if (newStartDate > newEndDate) {
      setEndDate(newStartDate);
    }
  }, []);

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    validateDates(newStartDate, endDate);
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;

    if (newEndDate >= startDate && newEndDate <= today) {
      setEndDate(newEndDate);
    }
  };

  const handleApply = () => {
    const isDefaultRange = startDate === defaultStartDate && endDate === defaultEndDate;
    onApply({ startDate, endDate, defaultRange: isDefaultRange });
    onClose();
  };

  const handleReset = () => {
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
    onApply({ ...getDefaultDateRange(), defaultRange: true });
    onClose();
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box
        sx={{
          width: 300,
          padding: 3,
          mt: 8,
          backgroundColor: '#f9f9f9',
          height: '100vh',
        }}
      >
        <Typography variant="h6" gutterBottom>
          Filter By Date
        </Typography>

        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
          Start Date
        </Typography>
        <TextField
          type="date"
          fullWidth
          value={startDate}
          onChange={handleStartDateChange}
          sx={{ mb: 2 }}
          inputProps={{ max: today, min: "2024-12-01" }}
        />

        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
          End Date
        </Typography>
        <TextField
          type="date"
          fullWidth
          value={endDate}
          onChange={handleEndDateChange}
          sx={{ mb: 3 }}
          inputProps={{ max: today, min: startDate }}
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleApply}
          disabled={!startDate || !endDate}
        >
          Apply Filters
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={handleReset}
          sx={{ mt: 2 }}
        >
          Reset Filters
        </Button>
      </Box>
    </Drawer>
  );
};

export default DashboardFilters;
